export default __webpack_public_path__ + "static/media/clock-circle.eb8d391f.svg";